import React from "react";
import { Link } from "react-router-dom";
import { Pencil } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ASSETS } from "@/lib/assets";
import BadgeCard from "@/components/BadgeCard";

function ChainTag({ type }) {
  const sol = type === "solana";
  return <span className={`tag !text-[9px] !px-2 !py-0.5 ${sol ? "bg-grape text-cream" : "bg-neon text-black"}`}>{sol ? "SOLANA" : "EVM"}</span>;
}

export default function Profile() {
  const { user } = useAuth();
  if (!user) return null;
  const initial = (user.displayName || user.name || "R").charAt(0).toUpperCase();
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16">
      <div className="comic-card p-6 sm:p-8 relative overflow-hidden">
        <div className="halftone absolute inset-0 opacity-30" />
        <div className="relative flex flex-col sm:flex-row gap-6 items-start">
          {user.picture
            ? <img src={user.picture} alt="avatar" className="w-24 h-24 rounded-full border-3 border-neon" />
            : <span className="w-24 h-24 rounded-full bg-neon text-black font-display font-900 flex items-center justify-center text-4xl">{initial}</span>}
          <div className="flex-1">
            <h1 className="font-display font-900 text-cream text-3xl">{user.displayName || user.name}</h1>
            {user.username && <p className="font-mono text-neon text-sm">@{user.username}</p>}
            <p className="font-mono text-dim text-sm mt-3">{user.bio || "This member of the Robbed hasn't written a bio yet."}</p>
            <div className="flex flex-wrap gap-2 mt-4">
              {(user.wallets || []).map((w) => <ChainTag key={w.walletId} type={w.chainType} />)}
              {(user.authProviders || []).includes("google") && <span className="tag !text-[9px]">Google</span>}
            </div>
            <Link to="/settings" className="btn-ghost mt-6 !py-2 !px-4 !text-xs inline-flex"><Pencil className="w-4 h-4" /> Edit Profile</Link>
          </div>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4 mt-6">
        <BadgeCard />
        <div className="grid grid-cols-2 gap-4 content-start">
          <Link to="/my/memes" className="comic-card p-5 hover:border-neon"><img src={ASSETS.pointing} alt="" className="w-10 h-10 inline" /><p className="font-display font-900 text-cream uppercase text-sm mt-2">My Memes</p></Link>
          <Link to="/my/stories" className="comic-card p-5 hover:border-neon"><img src={ASSETS.shrugging} alt="" className="w-10 h-10 inline" /><p className="font-display font-900 text-cream uppercase text-sm mt-2">My Stories</p></Link>
        </div>
      </div>
    </div>
  );
}
